import { ajaxFunc } from '../tools';

const public_ = {
  // 获取连连钱包的状态信息
  weixin_login: ajaxFunc('/user/weixin_login', 'post')
};

export default public_;



// WEBPACK FOOTER //
// ./src/request/api/public.js